import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

import Header from '../Header'
import Portfolio from '../Portfolio'
import Atemption from '../../components/Atemption'
import routes from '../../config/routes'
import { fetchPages } from '../../model/pages/actions'

class App extends Component {
  componentDidMount = () => {
    this.props.fetchPages()
  }

  render() {
    return (
      <div>
        <Header />

        {routes.map(({ path, component, exact }) => (
          <Route key={path} path={path} exact={exact} component={component} />
        ))}
        <Route path={'/portfolio'} component={Portfolio} />
        <Atemption />
      </div>
    )
  }
}

export default connect(state => state, { fetchPages })(App)
